import React, { useState, useEffect } from 'react';
import { visiMisiService } from '../../services/visiMisiService';
import { FaSpinner, FaExclamationTriangle, FaFlag, FaBullseye } from 'react-icons/fa';

const VisiMisi = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        const result = await visiMisiService.getPublicVisiMisi();
        if (result.success) {
            setData(result.data?.data || result.data);
        } else {
            setError(result.message);
        }
        setLoading(false);
    };

    if (loading) {
        return (
            <div className="container mx-auto px-4 py-12 text-center">
                <FaSpinner className="animate-spin text-4xl text-[#2E7D32] mx-auto mb-4" />
                <p className="text-gray-500">Memuat data...</p>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="container mx-auto px-4 py-12">
                <div className="card-glass text-center py-12">
                    <FaExclamationTriangle className="text-5xl text-yellow-500 mx-auto mb-4" />
                    <h2 className="text-xl font-bold text-gray-700 mb-2">Data Belum Tersedia</h2>
                    <p className="text-gray-500">{error || 'Visi dan misi belum diinput oleh admin'}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-bold text-[#0F4C3A] mb-4">
                    Visi dan Misi
                </h1>
                {data.judul_utama && (
                    <p className="text-xl md:text-2xl font-bold text-[#2E7D32] tracking-wide">
                        {data.judul_utama}
                    </p>
                )}
            </div>

            {/* Visi */}
            <div className="card-glass mb-8 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0F4C3A] to-[#4CAF50]"></div>
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#0F4C3A] to-[#2E7D32] rounded-xl flex items-center justify-center">
                        <FaFlag className="text-white text-xl" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-bold text-[#0F4C3A]">VISI</h2>
                        <p className="text-sm text-gray-500">Periode {data.periode}</p>
                    </div>
                </div>
                <blockquote className="text-lg md:text-xl text-gray-700 italic border-l-4 border-[#2E7D32] pl-6 py-2">
                    "{data.visi}"
                </blockquote>
            </div>

            {/* Misi */}
            <div className="card-glass relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0F4C3A] to-[#4CAF50]"></div>
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 bg-gradient-to-br from-[#0F4C3A] to-[#2E7D32] rounded-xl flex items-center justify-center">
                        <FaBullseye className="text-white text-xl" />
                    </div>
                    <div>
                        <h2 className="text-2xl font-bold text-[#0F4C3A]">MISI</h2>
                        <p className="text-sm text-gray-500">{data.misi?.length || 0} misi utama</p>
                    </div>
                </div>

                <ol className="space-y-4">
                    {data.misi?.map((misi, index) => (
                        <li key={index} className="flex items-start gap-4 group">
                            <span className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-[#0F4C3A] to-[#2E7D32] text-white rounded-lg flex items-center justify-center font-bold shadow-md group-hover:scale-110 transition-transform">
                                {index + 1}
                            </span>
                            <span className="text-lg text-gray-700 pt-1.5">
                                {misi}
                            </span>
                        </li>
                    ))}
                </ol>
            </div>

            {/* Deskripsi Tambahan */}
            {data.deskripsi && (
                <div className="card-glass mt-8 bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] text-white">
                    <p className="text-center leading-relaxed">{data.deskripsi}</p>
                </div>
            )}
        </div>
    );
};

export default VisiMisi;